import React from 'react';
import { RadioGroup as MuiRadioGroup, FormControl, FormLabel, FormHelperText, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {};

const propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  helperText: PropTypes.node,
  label: PropTypes.node,
};
const defaultProps = {
  label: undefined,
  helperText: undefined,
};

function RadioGroup({ children, classes, label, helperText, ...rest }) {
  return (
    <FormControl component="fieldset">
      {label ? <FormLabel component="legend">{label}</FormLabel> : null}

      <MuiRadioGroup {...rest}>{children}</MuiRadioGroup>

      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;

export default withStyles(styles)(RadioGroup);
